/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';

$(document).ready(function () {

  //it seems can not have quick view on the product page
  createProductSpin();
  createInputFile();
  // coverImage();
  // imageScrollBox();
  $('body').on('change', '.product-variants [data-product-attribute]', function () {
    $('.product-variants [data-product-attribute]').prop('disabled', 'disabled');
    $('.product-variants-item .input-container').removeClass('st-input-clicked');
    $(this).parent().addClass('st-input-clicked');
  });

  prestashop.on('updatedProduct', function (event) {
    //copied from _core\js\product.js
    function replaceAddToCartSection(replacement) {
      let replace = replacement.$addToCartSnippet.find(replacement.targetSelector);

      if ($(replacement.$targetParent.find(replacement.targetSelector)).length > 0) {
        if (replace.length > 0) {
          $(replacement.$targetParent.find(replacement.targetSelector)).replaceWith(replace[0].outerHTML);
        } else {
          $(replacement.$targetParent.find(replacement.targetSelector)).html('');
        }
      }
    }
    //copied end
    var $addToCartSnippet = $(event.product_add_to_cart);
    if($addToCartSnippet.hasClass('product-add-to-cart'))
    {
      replaceAddToCartSection({
        $addToCartSnippet: $addToCartSnippet,
        $targetParent: $('.product-add-to-cart'),
        targetSelector: '#product-availability'
      });//added in code since v1.7.1.2 still need to keep it here
      replaceAddToCartSection({
        $addToCartSnippet: $addToCartSnippet,
        $targetParent: $('.product-add-to-cart'),
        targetSelector: '.product-availability-date'
      });
    }
    var $productReference = $('.product-information .product-reference .pro_extra_info_content');
    var $productReference_new = $(event.product_details).find('.product-reference span');
    if($productReference.length && $productReference_new.length)
      $productReference.html($productReference_new.html());
    //
    createInputFile();
    // coverImage();
    if (event && event.product_minimal_quantity) {
      const minimalProductQuantity = parseInt(event.product_minimal_quantity, 10);
      const quantityInputSelector = '#quantity_wanted';
      let quantityInput = $(quantityInputSelector);

      // @see http://www.virtuosoft.eu/code/bootstrap-touchspin/ about Bootstrap TouchSpin
      quantityInput.trigger('touchspin.updatesettings', {min: minimalProductQuantity});
    }
    // imageScrollBox();
    // $($('.tabs .nav-link.active').attr('href')).addClass('active').removeClass('fade');
    // $('.js-product-images-modal').replaceWith(event.product_images_modal);
    $('.product-variants [data-product-attribute]').prop('disabled', false);
  });


  function coverImage() {
    $('.js-thumb').on(
      'click',
      (event) => {
        $('.js-modal-product-cover').attr('src',$(event.target).data('image-large-src'));
        $('.selected').removeClass('selected');
        $(event.target).addClass('selected');
        $('.js-qv-product-cover').prop('src', $(event.currentTarget).data('image-large-src'));
      }
    );
  }

  function imageScrollBox()
  {
    if ($('#main .js-qv-product-images li').length > 2) {
      $('#main .js-qv-mask').addClass('scroll');
      $('.scroll-box-arrows').addClass('scroll');
        $('#main .js-qv-mask').scrollbox({
          direction: 'h',
          distance: 113,
          autoPlay: false
        });
        $('.scroll-box-arrows .left').click(function () {
          $('#main .js-qv-mask').trigger('backward');
        });
        $('.scroll-box-arrows .right').click(function () {
          $('#main .js-qv-mask').trigger('forward');
        });
    } else {
      $('#main .js-qv-mask').removeClass('scroll');
      $('.scroll-box-arrows').removeClass('scroll');
    }
  }

  function createInputFile()
  {
    $('.js-file-input').on('change', (event) => {
      let target, file;

      if ((target = $(event.currentTarget)[0]) && (file = target.files[0])) {
        $(target).prev().text(file.name);
      }
    });
  }

  function createProductSpin()
  {
    let quantityInput = $('#quantity_wanted');
    quantityInput.TouchSpin({
      // verticalbuttons: !sttheme.is_mobile_device,
      verticalupclass: 'fto-plus-2',
      verticaldownclass: 'fto-minus',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',
      min: parseInt(quantityInput.attr('min'), 10),
      max: 1000000
    });

    quantityInput.on('change', function (event) {
      let $productRefresh = $('.product-refresh');
      $(event.currentTarget).trigger('touchspin.stopspin');
      $productRefresh.trigger('click', {eventType: 'updatedProductQuantity'});
      event.preventDefault();

      return false;
    });
  }
  $('.pro_grid_thumbs .swiper-slide').click(function(){
    $(this).addClass('clicked_thumb').siblings().removeClass('clicked_thumb');
    if(typeof($('.pro_gallery_top')[0].swiper)!=='undefined')
      $('.pro_gallery_top')[0].swiper.slideTo($(this).index());
  });
  $('body').on('click', '.pro_gallery_show_all', function (event) {
    if(typeof(sttheme.pro_images)!=='undefined' && sttheme.pro_images)
    {
        var product_left_column = $(this).closest('.product_left_column');
        if(!product_left_column.length)
            return false;

        var pro_gallery_top = '', pro_gallery_thumbs='';
        if($('.pro_gallery_top', product_left_column).length && typeof($('.pro_gallery_top', product_left_column)[0].swiper)!=='undefined')
            pro_gallery_top = $('.pro_gallery_top', product_left_column)[0].swiper;
        if($('.pro_gallery_thumbs', product_left_column).length && typeof($('.pro_gallery_thumbs', product_left_column)[0].swiper)!=='undefined')
            pro_gallery_thumbs = $('.pro_gallery_thumbs', product_left_column)[0].swiper;
        var curr_image_ids = new Array();
        $.each($('.pro_gallery_item', product_left_column),function(){
            curr_image_ids.push($(this).data('id_image'));
        });
        var pro_popup_trigger = $('.pro_popup_trigger_box', product_left_column);
        
            $.each(sttheme.pro_images,function(index, image){
                if($.inArray(parseInt(image.id_image, 10), curr_image_ids)<0){
                    //no need to lazy load
                    if(pro_gallery_top)
                        pro_gallery_top.appendSlide('<div class="swiper-slide"><div class="easyzoom--overlay '+(sttheme.enable_zoom ? ' easyzoom ' : '')+(sttheme.enable_zoom==2 ? ' disable_easyzoom_on_mobile ' : '')+'"> <a href="'+(sttheme.enable_zoom || sttheme.enable_thickbox ? image.bySize.superlarge_default.url : 'javascript:;')+'" class="'+(sttheme.enable_thickbox && !sttheme.enable_zoom ? ' st_popup_image st_pro_popup_image ' : '')+' replace-2x" '+(sttheme.enable_thickbox && !sttheme.enable_zoom ? ' data-group="pro_gallery_popup" ' : '')+' title="'+image.legend+'"><img class="pro_gallery_item" src="'+image['bySize'][sttheme.gallery_image_type]['url']+'" '+(sttheme.retina && typeof(image['bySize'][sttheme.gallery_image_type+'_2x'])!=='undefined' ? 'srcset="'+image['bySize'][sttheme.gallery_image_type+'_2x']['url']+' 2x"' : '')+' alt="'+image.legend+'" title="'+image.legend+'" width="'+image['bySize'][sttheme.gallery_image_type]['width']+'" height="'+image['bySize'][sttheme.gallery_image_type]['height']+'" data-id_image="'+image.id_image+'" /></a></div></div>');
                    if(pro_gallery_thumbs)
                        pro_gallery_thumbs.appendSlide('<div class="swiper-slide"><div class="pro_gallery_thumb_box general_border"><img class="pro_gallery_thumb" src="'+image['bySize'][sttheme.thumb_image_type]['url']+'" '+(sttheme.retina && typeof(image['bySize'][sttheme.thumb_image_type+'_2x'])!=='undefined' ? 'srcset="'+image['bySize'][sttheme.thumb_image_type+'_2x']['url']+' 2x"' : '')+' alt="'+image.legend+'" title="'+image.legend+'" width="'+image['bySize'][sttheme.thumb_image_type]['width']+'" height="'+image['bySize'][sttheme.thumb_image_type]['height']+'" /></div></div>');

                    pro_popup_trigger.append('<a href="'+image.bySize.superlarge_default.url+'" class="pro_popup_trigger st_popup_image st_pro_popup_image replace-2x layer_icon_wrap" data-group="pro_gallery_popup" title="'+image.legend+'"><i class="fto-resize-full"></i></a>');
                }
            });


          if(pro_gallery_top){
            $('.images-container').removeClass('pro_number_0 pro_number_1 pro_number_2 pro_number_3 pro_number_4 pro_number_5 pro_number_6').addClass('pro_number_'+sttheme.pro_images.length);//before update
            //For some resion, can not do update() immediately, appendSlide taks time or Images take time to load, wo bu zhi dao
            pro_gallery_top.update(true);
            if($(pro_gallery_top.slides).length>$(pro_gallery_top.slides).filter('.swiper-slide-visible').length)
            {
              $(pro_gallery_top.params.nextButton).show();
              $(pro_gallery_top.params.prevButton).show();
            }
          }
          if(pro_gallery_thumbs){
            //for some reason
            pro_gallery_thumbs.update(true);
            if($(pro_gallery_thumbs.slides).length>$(pro_gallery_thumbs.slides).filter('.swiper-slide-visible').length)
            {
              $(pro_gallery_thumbs.params.nextButton).show();
              $(pro_gallery_thumbs.params.prevButton).show();
            }
          }
          
        //copied from popup_master function in the theme.js
          $('.st_pro_popup_image').magnificPopup({
              type: 'image',
              tLoading: '',
              image: {
                    verticalFit: !!sttheme.popup_vertical_fit
                },
              gallery:{
                enabled:true
              }
            });
        //
        prestashop.emit('updatedProductImages');
    }
    $(this).hide();
    /*$.post(event.reason.productUrl, {ajax: '1', action: 'refresh'}, null, 'json').then(function(resp) {
      $('.images-container').replaceWith(resp.product_cover_thumbnails);
      prestashop.emit('updatedProductImages');
    });*/
  });
});



// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js


// WEBPACK FOOTER //
// ./js/product.js